<template>
	<div :class="box_class">
		<ul v-if="type == 'tabs'" class="nav nav-tabs">
			<li
				v-for="(tab, index) in tabs"
				:key="index"
				@click="$emit('input', tab.cod)"
				:class="value == tab.cod ? 'active' : ''"
			>
				<a v-html="tab.title"></a>
			</li>
			<li
				v-if="$slots.tools != undefined"
				class="pull-right box-tools-tabs"
			>
				<slot name="tools" />
			</li>
		</ul>
		<div
			v-else-if="type != 'tabs' && title != undefined"
			class="box-header with-border"
		>
			<h3 class="box-title" v-html="title"></h3>
			<div v-if="$slots.tools != undefined" class="box-tools pull-right">
				<slot name="tools" />
			</div>
		</div>
		<div
			v-if="$slots.body != undefined"
			class="box-body"
			:class="{ 'no-padding': noPadding != undefined }"
		>
			<slot name="body" />
		</div>
		<div v-if="$slots.footer != undefined" class="box-footer">
			<slot name="footer" />
		</div>
	</div>
</template>
<script>
	export default {
		name: 'AppBox',
		props: ['type', 'title', 'no-padding', 'tabs', 'value'],
		computed: {
			box_class() {
				if (this.type == 'tabs') {
					return 'nav-tabs-custom';
				} else {
					if (this.type != undefined) {
						return `box box-${this.type}`;
					} else {
						return 'box';
					}
				}
			},
		},
	};
</script>
<style scoped>
	.nav-tabs li a {
		cursor: pointer;
	}
	h3.box-title {
		font-size: 17px;
	}
	.box-tools-tabs {
		padding: 4px;
	}
</style>



// WEBPACK FOOTER //
// src/app-components/box.vue